import { Questionnaire } from './questionnaire.model';
import { parseISO } from 'date-fns';

// Without this dynamic parameter AOT compiling will fail.
// @see https://angular.io/guide/angular-compiler-options#strictmetadataemit
// @dynamic
export class Session {
  public grade!: string;
  public id!: string;

  public startedAt?: Date;

  public finishedAt?: Date;

  public lastVisitedAt?: Date;

  public questionnaire!: Questionnaire;
  public questionsCorrect!: number;
  public totalQuestions!: number;

  public tags!: string[];

  public static fromDto(dto: any): Session {
    const session: Session = new Session();
    session.grade = dto.grade;
    session.id = dto.id;
    session.startedAt = dto.startedAt ? parseISO(dto.startedAt) : undefined;
    session.finishedAt = dto.finishedAt ? parseISO(dto.finishedAt) : undefined;
    session.lastVisitedAt = dto.lastVisitedAt
      ? parseISO(dto.lastVisitedAt)
      : undefined;
    session.questionnaire = dto.questionnaire
      ? Questionnaire.fromDto(dto.questionnaire)
      : undefined!;
    session.questionsCorrect = dto.questionsCorrect;
    session.totalQuestions = dto.totalQuestions;
    session.tags = dto.tags ?? [];
    return session;
  }
}
